

import React from 'react';

const PurchaseOrderReport = React.forwardRef(({ data }, ref) => (
  <div ref={ref} style={{ padding: '10pt', fontFamily: 'Arial', color: 'black', width: '575pt', backgroundColor: 'white' }}>
    <h1 style={{ fontSize: '14pt', textAlign: 'center' }}>Purchase Order Report</h1>
    
    <div style={{ marginBottom: '20pt' }}>
      <p style={{ fontSize: '10pt' }}><strong>Purchase Order #:</strong> {data.purchaseOrderNumber}</p>
      <p style={{ fontSize: '10pt' }}><strong>Date:</strong> {data.date}</p>
      <p style={{ fontSize: '10pt' }}><strong>Party Name:</strong> {data.partyName}</p>
      <p style={{ fontSize: '10pt' }}><strong>Reference #:</strong> {data.referenceNumber}</p>
      <p style={{ fontSize: '10pt' }}><strong>Expected Delivery Date:</strong> {data.expectedDeliveryDate}</p>
      <p style={{ fontSize: '10pt' }}><strong>Payment Terms:</strong> {data.paymentTerms}</p>
      <p style={{ fontSize: '10pt' }}><strong>Shipment Preference:</strong> {data.shipmentPreference}</p>
    </div>
    
    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20pt' }}>
      <div style={{ width: '45%' }}>
        <h2 style={{ fontSize: '12pt' }}>Billing Address</h2>
        <table border="1" cellPadding="5" cellSpacing="0" style={{ width: '100%', fontSize: '10pt', borderCollapse: 'collapse' }}>
          <tbody>
            <tr>
              <td><strong>Address:</strong></td>
              <td>{data.billingAddress}</td>
            </tr>
            {/* Add more rows for other billing address details if necessary */}
          </tbody>
        </table>
      </div>

      <div style={{ width: '45%' }}>
        <h2 style={{ fontSize: '12pt' }}>Shipping Address</h2>
        <table border="1" cellPadding="5" cellSpacing="0" style={{ width: '100%', fontSize: '10pt', borderCollapse: 'collapse' }}>
          <tbody>
            <tr>
              <td><strong>Address:</strong></td>
              <td>{data.shippingAddress}</td>
            </tr>
            {/* Add more rows for other shipping address details if necessary */}
          </tbody>
        </table>
      </div>
    </div>
    
    <table border="1" cellPadding="5" cellSpacing="0" style={{ width: '100%', fontSize: '10pt', borderCollapse: 'collapse', marginBottom: '20pt' }}>
      <thead>
        <tr>
          <th style={{ padding: '5pt' }}>Product</th>
          <th style={{ padding: '5pt' }}>Account</th>
          <th style={{ padding: '5pt' }}>Quantity</th>
          <th style={{ padding: '5pt' }}>Rate</th>
          <th style={{ padding: '5pt' }}>Amount</th>
        </tr>
      </thead>
      <tbody>
        {data.products.map((product, index) => (
          <tr key={index}>
            <td style={{ padding: '5pt' }}>{product.code} - {product.description}</td>
            <td style={{ padding: '5pt' }}>{product.account}</td>
            <td style={{ padding: '5pt' }}>{product.quantity}</td>
            <td style={{ padding: '5pt' }}>{product.rate}</td>
            <td style={{ padding: '5pt' }}>{product.amount}</td>
          </tr>
        ))}
      </tbody>
    </table>

    <div style={{ marginTop: '20pt' }}>
      <h2 style={{ fontSize: '12pt' }}>Summary</h2>
      <table border="1" cellPadding="5" cellSpacing="0" style={{ width: '100%', fontSize: '10pt', borderCollapse: 'collapse' }}>
        <tbody>
          <tr>
            <td style={{ padding: '5pt' }}><strong>Subtotal:</strong></td>
            <td style={{ padding: '5pt', textAlign: 'right' }}>{data.subtotal}</td>
          </tr>
          <tr>
            <td style={{ padding: '5pt' }}><strong>Total Quantity:</strong></td>
            <td style={{ padding: '5pt', textAlign: 'right' }}>{data.totalQuantity}</td>
          </tr>
          <tr>
            <td style={{ padding: '5pt' }}><strong>Discount:    {data.discountPercentage}</strong></td>
            <td style={{ padding: '5pt', textAlign: 'right' }}>{data.discountValue}</td>
          </tr>
          <tr>
            <td style={{ padding: '5pt' }}><strong>Adjustment:</strong></td>
            <td style={{ padding: '5pt', textAlign: 'right' }}>{data.adjustment}</td>
          </tr>
          <tr>
            <td style={{ padding: '5pt' }}><strong>TCS:    {data.tcsPercentage}</strong></td>
            <td style={{ padding: '5pt', textAlign: 'right' }}>{data.tcsValue}</td>
          </tr>
          <tr>
            <td style={{ padding: '5pt' }}><strong>Total:</strong></td>
            <td style={{ padding: '5pt', textAlign: 'right' }}>{data.total}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div style={{ marginTop: '20pt' }}>
      <p style={{ fontSize: '10pt' }}><strong>Customer Notes:</strong> {data.customerNotes}</p>
    </div>
  </div>
));

export default PurchaseOrderReport;



